import { inject, signal } from '@angular/core';
import { finalize, map, take } from 'rxjs';
import { InterceptSummary } from 'src/app/core/models/position-operations/intercepts.model';
import { RevenueRecoveryService } from 'src/app/core/services/revenue-recovery/revenue-recovery/revenue-recovery.service';
import { CommonUtils } from 'src/app/core/utils/common/common.utils';

export class Intercept {
  protected readonly intercepts = signal<InterceptSummary[]>([]);
  protected readonly _revenueRecoveryService = inject(RevenueRecoveryService);
  readonly commonUtils = inject(CommonUtils);

  getIntercepts() {
    this.commonUtils.updateLoadingModal(true);
    this.commonUtils.lockUpdateLoadingModal(true);
    return this._revenueRecoveryService.getIntercepts(true).pipe(
      take(1),
      map((data) => {
        this.intercepts.set(data?.response.intercepts || []);
      }),
      finalize(() => {
        this.commonUtils.lockUpdateLoadingModal(false);
        this.commonUtils.updateLoadingModal(false);
      }),
    );
  }
}
